const fields = [
  {
    name: "name",
    label: "Catgeory Name",
    value: "name",
  },
];

export default fields;
